import { BaseItemStore } from "../../core/BaseStore";
import type { BusinessFeedCommentModel } from "./BusinessFeedCommentModel";

export default class BusinessFeedCommentsStore extends BaseItemStore<BusinessFeedCommentModel> {}
